import KendoNotificationMixin from './KendoNotificationMixin'

export default {
    name: 'kendo-notification',
    mixins: [ KendoNotificationMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-popups-vue-wrapper/src/KendoNotification/index.js